<div  >

  @if (display) {
    <div>
      @if (hidePage) {
        <div class="container">
          <div class="header-wrapper "  style="width: 100%" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="logo">
              <calsoft-logo [sitename]="data.siteName" [type]="'dark'"></calsoft-logo>
            </div>
            <div fxLayout="row" fxFlex="90">
              <mat-toolbar-row  fxHide fxShow.gt-sm class="container" fxLayout="row" fxLayout.xs="row"
                fxLayoutAlign="space-between center" style="color: #000000;margin: 0px;padding: 0 25px;">
                <calsoft-Menu  [newcolor]="true" [color]="true" [data]="data" [type]="'one'" style="color: #000000;" class="menu"
                [categoryArray]="item"></calsoft-Menu>
              </mat-toolbar-row>
              <!-- <button mat-button fxLayoutAlign="end center">
                <mat-icon (click)="callPhone()" style="color: black;    height: auto;
                width: auto;
                top: 11px;">phone_in_talk</mat-icon>
              </button> -->
              <!-- <calsoft-cart-icon [data]="data"  fxFlex></calsoft-cart-icon> -->
            </div>
          </div>
        </div>
      }
      @if (!hidePage) {
        <div class="header container">
          <div class="header-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
            <div >
              <calsoft-logo [sitename]="data.siteName" [type]="'white'"></calsoft-logo>
            </div>
            <div fxLayout="row" fxFlex="90">
              <mat-toolbar-row fxHide fxShow.gt-sm class="container" fxLayout="row" fxLayout.xs="row"
                fxLayoutAlign="space-between center" style="margin: 0px;padding: 0 25px;">
              
                <calsoft-Menu [color]="true" [data]="data" [type]="'one'" style="color: #000000;" class="menu"
                [categoryArray]="item"></calsoft-Menu>
              </mat-toolbar-row>
              <!-- <button mat-button fxLayoutAlign="end center">
                <mat-icon (click)="callPhone()" style="color: white;">phone_in_talk</mat-icon>
              </button> -->
              <!-- <calsoft-cart-icon [data]="data"  fxFlex></calsoft-cart-icon> -->
            </div>
          </div>
        </div>
      }
      <mat-toolbar style="z-index: 1000;width: 100%;background-color: white;" fxHide fxShow.gt-md fxShow.md  class="calsoft-fixed-header bg toolbar-container"
        fxLayout="row"
        >
        <mat-toolbar-row style="height: 100%;"  fxLayoutAlign="space-between center">
        <div class="header-wrapper container"  style="width: 100%" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="logo">
            <calsoft-logo [sitename]="data.siteName" [type]="'dark'"></calsoft-logo>
          </div>
          <div fxLayout="row" fxFlex="90">
            <mat-toolbar-row fxHide fxShow.gt-sm class="container" fxLayout="row" fxLayout.xs="row"
              fxLayoutAlign="space-between center" style=" margin: 0px;padding: 0 10px;">
              <calsoft-Menu  [newcolor]="true" [color]="true" [data]="data" [type]="'one'" style="color: #000000;" class="menu"
              [categoryArray]="item"></calsoft-Menu>
            </mat-toolbar-row>
            <!-- <button mat-button fxLayoutAlign="end center">
              <mat-icon (click)="callPhone()" style="color: black;">phone_in_talk</mat-icon>
            </button> -->
            <!-- <calsoft-cart-icon [data]="data"  fxFlex></calsoft-cart-icon> -->
          </div>
        </div>
        </mat-toolbar-row>
      </mat-toolbar>
    </div>
  }
</div>
@if (!display) {
  <div>
    <!-- @if (mobileHeaderType==1) {
      <div>
        <calsoft-mobile-header [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header>
      </div>
    }
    @if (mobileHeaderType==0) {
      <div>
        <calsoft-mobile-header-new [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header-new>
      </div>
    }
    @if (mobileHeaderType==2) {
      <div>
        <calsoft-mobile-header3 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header3>
      </div>
    }
    @if (mobileHeaderType==3) {
      <div>
        <calsoft-mobile-header4 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header4>
      </div>
    }
    @if (mobileHeaderType==4) {
      <div>
        <calsoft-mobile-header5 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header5>
      </div>
    }
    @if (mobileHeaderType==5) {
      <div>
        <calsoft-mobile-header6 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header6>
      </div>
    }
    @if (mobileHeaderType==6) {
      <div>
        <calsoft-mobile-header7 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header7>
      </div>
    }
    @if (mobileHeaderType==7) {
      <div>
        <calsoft-mobile-header8 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header8>
      </div>
    } -->
    @if (mobileHeaderType==8) {
      <div>
        <calsoft-mobile-header9 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header9>
      </div>
    }
  </div>
}